/** Sessão do portal de administração (laboratório de IA). */
const CHAVE_SESSAO = 'xadrez-admin-sessao';

/** Senha do portal admin (também enviada como token da API). */
export const SENHA_ADMIN = 'Toquinho123';

export function adminAutenticado(): boolean {
  try {
    return sessionStorage.getItem(CHAVE_SESSAO) === '1';
  } catch {
    return false;
  }
}

export function autenticarAdmin(senha: string): boolean {
  if (senha !== SENHA_ADMIN) return false;
  try {
    sessionStorage.setItem(CHAVE_SESSAO, '1');
    sessionStorage.setItem('xadrez-admin-token', SENHA_ADMIN);
  } catch {
    /* ignore */
  }
  return true;
}

export function sairAdmin(): void {
  try {
    sessionStorage.removeItem(CHAVE_SESSAO);
    sessionStorage.removeItem('xadrez-admin-token');
  } catch {
    /* ignore */
  }
}

export function tokenAdmin(): string | null {
  try {
    if (!adminAutenticado()) return null;
    return sessionStorage.getItem('xadrez-admin-token') || SENHA_ADMIN;
  } catch {
    return null;
  }
}
